// There's 10 colors per scale, index 0-9
export function getRankColor(rank?: number): string {
  let color = '';
  if (rank >= 1 && rank <= 3) {
    color = 'bg-gradient-to-tr from-performanceScale-13 to-performanceScale-13';
  } else if (rank >= 4 && rank <= 10) {
    color = 'bg-gradient-to-tr from-performanceScale-410 to-performanceScale-410';
  } else if (rank >= 11 && rank <= 20) {
    color = 'bg-gradient-to-tr from-performanceScale-1120 to-performanceScale-1120';
  } else if (rank >= 21 && rank <= 50) {
    color = 'bg-gradient-to-tr from-performanceScale-2150 to-performanceScale-2150';
  } else if (rank >= 51 && rank <= 100) {
    color = 'bg-gradient-to-tr from-performanceScale-51100 to-performanceScale-51100';
  } else {
    color = 'bg-gradient-to-tr from-performanceScale-101 to-performanceScale-101';
  }
  return color;
}
